function AccountDeletion() {
    return (
        <div className="max-w-4xl mx-auto p-10 text-gray-800">
            <h1 className="text-3xl font-bold mb-6">Talktail 계정 및 데이터 삭제 요청</h1>

            <section className="mb-6">
                <p className="mb-4">
                    이 페이지는 <strong>Talktail 앱</strong> 사용자님께서 계정 및 관련 데이터를 삭제 요청하실 수 있도록 제공됩니다.
                </p>
                <p className="text-sm text-gray-600">
                    본 앱은 (주)크림오프에서 제공하며, 개인정보 보호를 위해 최선을 다하고 있습니다.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">📌 계정 삭제 요청 방법</h2>
                <ol className="list-decimal list-inside space-y-2 text-gray-700">
                    <li>
                        아래 이메일로 <strong>"계정 삭제 요청"</strong> 제목으로 요청 메일을 보내주세요.
                    </li>
                    <li>
                        이메일 본문에는 다음 정보를 포함해주세요:
                        <ul className="list-disc list-inside ml-6">
                            <li>등록된 기관명</li>
                            <li>사용자 ID (이메일)</li>
                            <li>삭제 요청 사유 (선택)</li>
                        </ul>
                    </li>
                    <li>
                        확인 후, 영업일 기준 <strong>7일 이내</strong>에 데이터 삭제를 완료하고 이메일로 안내드립니다.
                    </li>
                </ol>
                <p className="mt-4">
                    📧 이메일:{" "}
                    <a
                        href="mailto:talktail@creamoff.co.kr"
                        className="text-blue-600 underline"
                    >
                        talktail@creamoff.co.kr
                    </a>
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">🔐 삭제 또는 보관되는 데이터</h2>
                <ul className="list-disc list-inside text-gray-700 ml-4">
                    <li>계정 정보 (기관명, 이메일, 아이디 등)는 완전히 삭제됩니다.</li>
                    <li>
                        서비스 사용 로그 및 환자 데이터는 법적 의무(전자기록보존 등)에 따라 최대 1년간 보관될 수 있습니다.
                    </li>
                </ul>
                <p className="text-sm text-gray-500 mt-2">
                    * 관련 법령 또는 분쟁 대응을 위해 일부 정보는 일정 기간 동안 보존될 수 있습니다.
                </p>
            </section>

            <footer className="text-center text-sm text-gray-400 mt-10">
                ⓒ 2025 Creamoff Co., Ltd. All rights reserved.
            </footer>
        </div>
    );
}

export default AccountDeletion;
